export class TrackByFunctionFactory {
    static get(keyToTrack: string) {
        return (_index: number, item: any): string => item[keyToTrack];
    }
}
